const isPrimitive = (value: React.ReactNode): value is string | number =>
  typeof value === 'string' || typeof value === 'number';

export default isPrimitive;
